import React from 'react';
import { IconProps } from '.';

const SvgArrowChevronLeftBold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m14.94 2.94 2.12 2.12L10.122 12l6.94 6.94-2.122 2.12L5.88 12l9.06-9.06Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgArrowChevronLeftBold;
